import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { Table } from 'primeng/table';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { Tc } from '../../../core/_infrastructure/types/common';
import { RegInstalacionViewModel, FilterSearchingRegInstalacionViewModel, RegInstalacionItemViewModel } from './instalacion.types';
import { InstalacionService } from './instalacion.service';

@Component({
    selector: 'app-instalacion-list',
    templateUrl: './instalacion-list.component.html',
})
export class InstalacionListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;
    resultInstalacion: RegInstalacionViewModel;
    listTipoInstalacion: Tc[];
    listProvincia: Tc[];
    cols: any[];
    visibilitySpinner: boolean = false;
    public isCollapsed = false;

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private instalacionService: InstalacionService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit() {
        this.globalService.getProvincias().subscribe(res => {
            this.listProvincia = res;
        });
        this.globalService.getTiposInstalacion().subscribe(res => {
            this.listTipoInstalacion = res;
        });

        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Identificador', header: 'Identificador' },
            { field: 'Operador', header: 'Operador' },
            { field: 'NumRegistro', header: 'Num. Registro' },
            { field: 'IdTipoInstalacionDescripcion', header: 'Tipo Instalación' },
            { field: 'IdProvinciaDescripcion', header: 'Provincia' },
            { field: 'Direccion', header: 'Dirección' },
            { field: 'Localidad', header: 'Localidad' },
            { field: 'CodigoPostal', header: 'CP' },
            { field: 'Telefono', header: 'Teléfono' },
            { field: 'Email', header: 'Email' },
            { field: 'TecnicoResponsable', header: 'Técnico Responsable' },
            { field: 'FechaAlta', header: 'Fecha Alta' },
            { field: 'FechaBaja', header: 'Fecha Baja' },
            { field: 'Baja', header: 'Baja' },
        ];

        this.form = this.fb.group({
            Identificador: '',
            Operador: '',
            NumRegistro: '',
            IdTipoInstalacion: null,
            IdProvincia: null,
            Telefono: '',
            Email: '',
            TecnicoResponsable: '',
            Baja: false,
        });

        this.loadBack();
    }

    loadBack() {
        if (
            this.instalacionService.currentFilter.Identificador != '' ||
            this.instalacionService.currentFilter.Operador != '' ||
            this.instalacionService.currentFilter.NumRegistro != '' ||
            this.instalacionService.currentFilter.IdTipoInstalacion != null ||
            this.instalacionService.currentFilter.IdProvincia != null ||
            this.instalacionService.currentFilter.Telefono != '' ||
            this.instalacionService.currentFilter.Email != '' ||
            this.instalacionService.currentFilter.TecnicoResponsable != '' //||
            //(this.instalacionService.currentFilter.Baja != null)
        ) {
            this.form.patchValue({
                Identificador: this.instalacionService.currentFilter.Telefono,
                Operador: this.instalacionService.currentFilter.Operador,
                NumRegistro: this.instalacionService.currentFilter.NumRegistro,
                IdTipoInstalacion: this.instalacionService.currentFilter.IdTipoInstalacion,
                IdProvincia: this.instalacionService.currentFilter.IdProvincia,
                Telefono: this.instalacionService.currentFilter.Telefono,
                Email: this.instalacionService.currentFilter.Email,
                TecnicoResponsable: this.instalacionService.currentFilter.TecnicoResponsable,
                Baja: this.instalacionService.currentFilter.Baja,
            });

            this.onSearchButton();
        }
    }

    onSearchButton() {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.instalacionService.currentFilter.Identificador = this.form.value.Identificador;
        this.instalacionService.currentFilter.Operador = this.form.value.Operador;
        this.instalacionService.currentFilter.NumRegistro = this.form.value.NumRegistro;
        this.instalacionService.currentFilter.IdTipoInstalacion = this.form.value.IdTipoInstalacion;
        this.instalacionService.currentFilter.IdProvincia = this.form.value.IdProvincia;
        this.instalacionService.currentFilter.Telefono = this.form.value.Telefono;
        this.instalacionService.currentFilter.TecnicoResponsable = this.form.value.TecnicoResponsable;
        this.instalacionService.currentFilter.Email = this.form.value.Email;
        this.instalacionService.currentFilter.Baja = this.form.value.Baja;

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    Search(pageNumber: number, asc: number = 0, orderBy: string = 'Identificador') {
        this.loading = true;

        let model: FilterSearchingRegInstalacionViewModel = this.CreateModel();

        model.PageNumber = pageNumber;
        model.Asc = asc;
        model.OrderBy = orderBy;

        this.instalacionService.postGetPagedByFilter(model).subscribe(res => {
            this.resultInstalacion = res;

            this.loading = false;
        });
    }

    onSearchLazy(event: any) {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton() {
        this.form.setValue({
            Identificador: '',
            Operador: '',
            NumRegistro: '',
            IdTipoInstalacion: null,
            IdProvincia: null,
            Telefono: '',
            Email: '',
            TecnicoResponsable: '',
            Baja: false,
        });

        this.searchingButton = false;
        this.isCollapsed = false;

        this.resultInstalacion = new RegInstalacionViewModel();
    }

    CreateModel() {
        let model: FilterSearchingRegInstalacionViewModel = new FilterSearchingRegInstalacionViewModel();

        Object.assign(model, this.form.value);

        return model;
    }

    onAdd() {
        this.router.navigate(['/mantenimiento/registros/instalaciones/create']);
    }

    onEdit(item: RegInstalacionItemViewModel) {
        this.router.navigate(['/mantenimiento/registros/instalaciones/edit', item.Id]);
    }

    onDelete(item: RegInstalacionItemViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro de dar de baja esta Instalación?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.instalacionService.deleteInstalacion(item.Id).subscribe({
                    next: () => {
                        this.addSuccessMessage('Instalación dada de baja correctamente');
                        this.onSearchButton();
                    },
                    error: () => this.addErrorMessage('Error al dar de baja la Instalación.'),
                });
            },
        });
    }

    onExportExcel() {
        this.visibilitySpinner = true;

        this.instalacionService.export(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);

            this.visibilitySpinner = false;
        });
    }
}
